import { defineComponent } from 'vue';

export default defineComponent({
    props: {
        participants: { type: String },
        text: { type: String },
    },
});
